import React, { useRef, useState } from "react";
import { Country } from "country-state-city";
import Flag from "react-world-flags";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import MUIErrorText from "../../MUIErrorText/MUIErrorText";
import { AppTheme } from "../../../theme/App.theme";

const CountryCodeDropdown = ({
  Value,
  OnChange,
  Label,
  SelectClass,
  Error,
  OnBlur,
  PlaceHolder,
  Disabled,
  Id,
  Name,
  SXForSelect,
  StyleForSelect,
  HelperText,
}) => {
  // Fetch countries with `country-state-city`
  const countries = [...Country.getAllCountries()].map((country) => {
    if (country.isoCode === "UM") {
      return {
        ...country,
        phonecode: "01",
      };
    } else {
      return country;
    }
  });
  const selectRef = useRef(null); // Reference to the Select component
  const [menuWidth, setMenuWidth] = useState(null);

  const handleOpen = () => {
    if (selectRef.current) {
      // Get the width of the Select component
      setMenuWidth(selectRef.current.offsetWidth);
    }
  };

  return (
    <FormControl fullWidth size={"small"}>
      <InputLabel
        id={Label}
        style={{ fontSize: "14px", color: Error && "#f15750" }}
        size={"small"}
      >
        {Label}
      </InputLabel>
      <Select
        labelId={Id ? Id : "my-id"}
        ref={selectRef}
        id={Id}
        input={<OutlinedInput label={Label} />}
        className={SelectClass}
        style={{
          ...StyleForSelect,
          backgroundColor: Disabled && AppTheme.MUTED_LIGHT,
        }}
        onOpen={handleOpen}
        sx={{
          ...SXForSelect,
          color: Value === "" && !Label && "#c5c5c5",
        }}
        name={Name}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
              maxWidth: menuWidth, // You can adjust this value
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            },
          },
        }}
        placeholder={PlaceHolder}
        fullWidth
        size="small"
        type="text"
        value={Value ? Value : ""}
        error={Error}
        onBlur={OnBlur}
        onChange={OnChange}
        disabled={Disabled ? Disabled : false}
        displayEmpty={PlaceHolder ? true : false}
      >
        {PlaceHolder && (
          <MenuItem value="" disabled style={{ textWrap: "wrap" }}>
            {PlaceHolder || "Country code"}
          </MenuItem>
        )}
        {countries.map((country, index) => (
          <MenuItem
            key={index}
            value={country.phonecode}
            id={country.isoCode}
            style={{
              textWrap: 'wrap',
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            className="custom-textfield-select"
          >
            <div className="d-flex align-items-center gap-1">
              <Flag code={country.isoCode} style={{ width: "24px" }} />
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {country.name} (+{country.phonecode})
              </span>
            </div>
          </MenuItem>
        ))}
      </Select>
      {Error && (
        <div className="ms-3">
          <MUIErrorText ErrorMessage={HelperText} />
        </div>
      )}
    </FormControl>
  );
};

export default CountryCodeDropdown;
